/**
 * Overlay Reducer
 */
import { Actions } from "components/OverLay/store/Actions";
import { Action, Reducer } from "redux";

// istanbul ignore next
const OverlayReducer: Reducer<boolean, Action> = (
  state: boolean = false,
  action: Action
): boolean => {
  if (action.type === Actions.SHOW_OVERLAY) return true;

  if (action.type === Actions.HIDE_OVERLAY) return false;

  return state;
};

export { OverlayReducer };



// WEBPACK FOOTER //
// ./src/components/OverLay/store/Reducer.tsx